import {User} from './user';

export class QDJiraIssue {
  id?: string;
  description: string;
  reporter: User;
  createdDate?: Date;
  updatedDate?: Date;
  updatedBy?: string;
  createdBy?: string;
  service: string;
  subject: string;
  type: string;

}
